import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, inject } from '@angular/core';

import { EmojiStoreService } from '../../emoji';

@Component({
  selector: 'app-reaction-selection',
  templateUrl: './reaction-selection.component.html',
  styleUrls: ['./reaction-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReactionSelectionComponent implements OnInit {
  private readonly store = inject(EmojiStoreService);

  @Output() reactionClicked = new EventEmitter<string>();

  frequentlyReactions: string[] = [];
  emojiListOpened = false;

  ngOnInit(): void {
    this.frequentlyReactions = this.store.getFrequentlyEmoji();
  }

  onClickReaction(emodjiName: string) {
    this.emojiListOpened = false;
    this.reactionClicked.emit(emodjiName);
  }
}
